import React, { useEffect } from "react";
import { isDesktop } from "../../../utils/utils";
import { IoIosSettings } from "react-icons/io";
import styled from "styled-components";
import { Link } from "react-router-dom";
const DoctorProfileHeader = ({ name }) => {
  if (isDesktop) return null;
  return (
    <Wrapper className="d-flex justify-content-between align-items-center bg-white shadow-sm position-fixed top-0 right-0 left-0 px-3 py-3">
      <strong className="text-dark">{name}</strong>
      <Link to="/doctor-settings">
        <IoIosSettings color="#000" size={28} />
      </Link>
    </Wrapper>
  );
};

export default DoctorProfileHeader;

const Wrapper = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  z-index: 10;
`;
